<form
  class="px-4"
  [formGroup]="formGroup" *transloco="let t; read 'company_edit';">

  <psc-input
    formControlName="companyName"
    [label]="t('company_name')"></psc-input>
  <psc-input
    *ngIf="selectedCountry === 'HR'"
    type="number"
    formControlName="companyOIB"
    label="OIB"></psc-input>
    <psc-input
    *ngIf="selectedCountry === 'BA'"
    type="number"
    formControlName="companyOIB"
    label="PDV"></psc-input>
  <psc-input
    formControlName="address"
    [label]="t('address')"></psc-input>
  <psc-select
    (ngModelChange)="countryChange($event)"
    [options]="countriesOptions"
    formControlName="country"
    [label]="t('country')"></psc-select>
  <psc-input
    type="url"
    formControlName="website"
    [label]="t('website')"></psc-input>
  <psc-input
    type="tel"
    formControlName="tel"
    [label]="t('telephone')"></psc-input>
  <psc-input
    type="email"
    formControlName="email"
    [label]="t('email')"></psc-input>

  <psc-file-input
    formControlName="logo"
    [label]="t('logo')"
  ></psc-file-input>

  <psc-textarea
    formControlName="description"
    [label]="t('description')"></psc-textarea>

  <div class="flex gap-10 mb-4">
    <psc-button
      [label]="t('add_new_company')"
      (buttonClicked)="saveCompany()">
    </psc-button>

    <psc-button
      *ngIf="!hideCancel"
      [label]="t('upsert.cancel')"
      (buttonClicked)="cancel.emit()"
      type="secondary-magenta"></psc-button>
  </div>
</form>
